import apps from "@services/applications";

export default [
  {
    path: "/app/attribute-manager",
    name: "attribute-manager",
    meta: {
      module: "attribute-manager",
      application: apps.Modules.AttributeManager.Id,
      title: "Attribute Manager"
    },
    component: () => import("@AttributeManager/views/AttributeEditor.vue"),
    children: []
  }
];
